<template>
  <el-container :style="parent" class="parent">
    <!-- <el-header>百雀羚产品防伪查询</el-header> -->
    <el-footer>
      <!-- <h3 style="text-align:center;">{{formlist.enterpriseName}}</h3> -->
      <!-- <el-carousel trigger="click">
        <el-carousel-item v-for="item in 4" :key="item">
          <el-image :src="src"></el-image>
        </el-carousel-item>
      </el-carousel>-->
      <el-image :src="src"></el-image>
    </el-footer>
    <el-row>
      <el-col :span="22" :offset="1">
        <!-- 第一次扫到正品码 -->
        <el-form
          ref="formlist"
          :model="formlist"
          style="text-align: left;"
          v-show="dialogVisible"
          class="mainform"
          center
        >
          <!-- 溯源信息 -->
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span style="color:#068cc4;">防伪查询结果</span>
            </div>
            <div class="text item">{{`你所查询的是广州超威生物科技有限公司旗下的威王除菌包官方正品，请放心使用。感谢你的支持和购买！`}}</div>
            <div class="text item">{{`首次查询时间：${formlist.create_time}`}}</div>
            <div class="text item">{{`扫码次数：${formlist.count}`}}</div>
            <div class="text item">{{`如非首次扫码，请注意是否假冒产品，如有疑问请拨打咨询电话：${'020-81251728'}`}}</div>
          </el-card>
          <div style="text-align: center;">
            <el-button
              type="danger"
              round
              style=" border: 3px solid #fff;box-shadow: 1px 1px 3px rgba(0,0,0,0.9);margin-bottom:10px;"
              @click="tolink()"
            > 
            立即购买</el-button>
          </div>
        </el-form>
        <!-- 第二次扫到正品码 -->
        <el-form
          ref="formlist"
          :model="formlist"
          style="text-align: left;"
          v-show="Visiblenext"
          class="mainform"
          center
        >
          <!-- 溯源信息 -->
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span style="color:#068cc4;">防伪查询结果</span>
            </div>
            <div class="text item">{{`你所查询的是广州超威生物科技有限公司旗下的威王除菌包官方正品，请放心使用。感谢你的支持和购买！`}}</div>
            <div class="text item">{{`首次查询时间：${formlist.create_time}`}}</div>
            <div class="text item">{{`扫码次数：${formlist.count}`}}</div>
            <div class="text item">{{`如非首次扫码，请注意是否假冒产品，如有疑问请拨打咨询电话：${'020-81251728'}`}}</div>
          </el-card>
          <div style="text-align: center;">
            <el-button
              type="danger"
              round
              style=" border: 3px solid #fff;box-shadow: 1px 1px 3px rgba(0,0,0,0.9);margin-bottom:10px;"
              @click="tolink()"
            >立即购买</el-button>
          </div>
        </el-form>
        <!-- 扫到假货 -->
        <el-form
          ref="formlist"
          :model="formlist"
          label-width="140px"
          v-show="Visible"
          class="mainform"
        >
          <h2 style="text-align:center;">系统维护中</h2>
        </el-form>
      </el-col>
      <!-- <el-divider></el-divider>
      <div v-show="packageLevel">您查询的是消费者扫产品的包装箱码，该产品相关信息如下:</div>
      <el-table border :data="this.formlist.extendList" style="width: 100%" v-show="packageLevel">
        <el-table-column prop="columnTitle" label="产品信息"></el-table-column>
        <el-table-column prop="columnValue" label></el-table-column>
      </el-table>-->
    </el-row>
  </el-container>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          resdata: {}
        };
      }
    }
  },
  data() {
    return {
      //接口参数
      packageLevel: false,
      qrcode: "",
      qlist: [],
      formlist: {},
      // 全屏css
      parent: {
        height: "600px"
      },
      footer: {
        height: "220px"
      },
      // 基础数据
      src: require("../../../assets/img/防伪页面.png"),
      dialogVisible: false,
      Visible: false,
      Visiblenext: false,
      information: null,
      informationarr: null,
      obj: {},
      content: ""
    };
  },
  mounted() {
    this.getheight();
    this.formlistget();
  },
  methods: {
    // 获取url参数
    // 获取浏览器高度
    getheight() {
      this.$data.parent.height =
        (window.innerHeight ||
          document.documentElement.clientHeight ||
          document.body.clientHeight) + "px";
      console.log(this.parent.height);
    },
    tolink() {
       window.location.href = "https://item.m.jd.com/product/100006288253.html?wxa_abtest=o&ad_od=share&utm_source=androidapp&utm_medium=appshare&utm_campaign=t_335139774&utm_term=CopyURL"
    },
    // 跟据链接参数调接口 100001522019091710010000561V06GT12
    formlistget() {
      let response = this.data.resdata;
      this.formlist = response.data;
      for (let i = 0; i < this.formlist.qlist.length; i++) {
        if (this.formlist.qlist[i].link == "") {
          this.formlist.qlist[i].link = "javascript:;";
        }
      }
      if (this.formlist.ifForgery === false) {
        this.Visible = true;
      } else {
        if (this.formlist.count == 1) {
          this.dialogVisible = true;
        } else {
          this.Visiblenext = true;
        }
      }
    }
  }
};
</script>
<style scoped>
.mainform {
  height: 60%;
}
.parent .el-main {
  padding: 5px 20px 15px;
}
.parent .el-header {
  height: 40px !important;
  font-size: 20px;
  background-color: #03a9f4;
  color: aliceblue;
  text-align: center;
  line-height: 40px;
  /* box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04); */
}
.parent .el-footer {
  /* box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04); */
  height: auto !important;
  margin-bottom: 0px;
  padding: 0 0px;
}
.parent .el-form-item--mini.el-form-item {
  margin-bottom: 0px;
}
.parent .el-form-item__label {
  text-align: left;
}
.hater {
  margin-top: 30px;
  font-size: 18px;
  font-weight: 600;
  color: #000000b3;
}
.parent .el-divider--horizontal {
  margin: 10px 0;
}
.text {
  font-size: 14px;
}
.item {
  margin-bottom: 8px;
}
.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both;
}

.box-card {
  margin: 10px 0;
  width: 100%;
}
.label_color_size .el-form-item__label {
  font-size: 18px;
  color: #52acff;
}
.el-button--mini.is-round {
  padding: 9px 18px;
  -webkit-tap-highlight-color: transparent;
  outline: none;
}
</style>